import React from "react";
import { Grid, Typography, CardHeader, CardContent } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { ChartCard } from "../Style/health-chart.style";

export default function HTNDMAgeGroupChart({ ageGroups, htnAgeGroup, dmAgeGroup }) {
    return (
        <Grid item xs={12} md={2} sx={{ width: "450px" }}>
            <ChartCard>
                <CardHeader
                    title={
                        <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: "bold", fontSize: "14px", textAlign: 'center', textDecorationLine: 'underline' }}
                        >
                            HTN/DM by Age Group
                        </Typography>
                    }
                    sx={{ pb: 0 }}
                />
                <CardContent>
                    <BarChart
                        xAxis={[{ scaleType: "linear" }]}
                        yAxis={[
                            {
                                width: 50,
                                scaleType: "band",
                                data: ageGroups,
                                tickLabelStyle: { fontSize: 12 },
                            },
                        ]}
                        series={[
                            {
                                data: dmAgeGroup,
                                label: "DM",
                                color: "#ff5722",
                            },
                            {
                                data: htnAgeGroup,
                                label: "HTN",
                                color: "#4caf50",
                            },
                        ]}
                        layout="horizontal"
                        height={425}
                        slotProps={{
                            legend: {
                                direction: "horizontal",
                                position: { horizontal: "center", vertical: "bottom" },
                            },
                        }}
                    />
                </CardContent>
            </ChartCard>
        </Grid>
    );
}
